import React, { ReactNode } from 'react';
import { ColorValue, StyleProp, View, ViewStyle } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import useCustomTheme from '../../../hooks/theme-hook';
import Label from '../Label';

interface MissionAcceptanceNoticeProps {
  message: string;
  color?: string;
  backgroundColor?: ColorValue;
  style?: StyleProp<ViewStyle>;
  children?: ReactNode;
}

const MissionAcceptanceNotice = ({ message, color, backgroundColor, style, children }: MissionAcceptanceNoticeProps) => {
  const theme = useCustomTheme();
  const textColor = color ?? theme.colorErrorPrimary.toString();

  return (
    <View style={[{ paddingHorizontal: 16, width: '100%' }, style]}>
      <View style={{ backgroundColor: backgroundColor ?? theme.colorErrorPrimaryBackground, paddingVertical: 12, paddingHorizontal: 16, borderRadius: 8, flexGrow: 1 }}>
        <View style={{ flexDirection: 'row', gap: 16, alignItems: 'center' }}>
          <FontAwesomeIcon style={{ flexShrink: 0 }} icon={faCircleExclamation} size={28} color={textColor} />
          <View style={{ flexShrink: 1 }}>
            <Label style={{ color: textColor, flexShrink: 1 }} numberOfLines={5}>{message}</Label>
          </View>
        </View>
        {children}
      </View>
    </View>
  );
};

export default MissionAcceptanceNotice;
